/**
 * DescriptionFacts rest of line (light) — year, genres, countries, etc.
 */
import Colors from '@shared/assets/style/default/color';
import Fonts from '@shared/assets/style/default/fonts';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

const DescriptionFactsRestText = styled.span<{ margin?: boolean }>`
  color: ${Colors['text']};
  display: block;
  font-family: ${Fonts['light']};
  font-size: ${32 * Screen.widthRatio}px;
  line-height: ${40 * Screen.widthRatio}px;
  margin-left: ${(props) =>
    props.margin ? `${8 * Screen.widthRatio}px` : '0'};
  max-width: ${820 * Screen.widthRatio}px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export default DescriptionFactsRestText;
